<app-table
    translatePrefix="workData.movementRestriction."
    [columns]="columns"
    [gridData]="store.data.getServiceEmailHistory()"
    [refreshCallback]="store.api.getServiceEmailHistory"
    [refreshCallbackFragment]="emailHistoryFrag"
    [additionalFilter]="additionalFilter"
    [showClearFilter]="false"
    [showColumnVisiblity]="false"
    [hideCheckboxes]="true"
    (detailCallback)="open($event)"
></app-table>

<div #dialogFooter></div>
